import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '../store';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TrybeService {

    baseUrl = 'https://api.try.be/'
    organisationId = '9a8ca4f6-229a-4d1f-8933-3ec3088ac426';


    getSiteId() {
        const basket = this.store.selectForLocal('basket');
        let hotel;
        if (basket.items.length) {
            console.log(basket.items[0].room.hotelId)
            return basket.items[0].room.hotelId;
        } else {
            const av = this.store.selectForLocal('availabilitySearch');
            hotel = av.hotel;
            return hotel.id;
        }


        // return 'HOTEL005';
    }



    constructor(
        private apiService: ApiService,
        private store: Store,
        private http: HttpClient,
    ) { }

    basketCreate() {

        const siteId = this.getSiteId();

        const dataToSend = {};
        return this.http.post(`${environment.apiV2Path}trybe/${siteId}/basket`, dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    basketGet(basketId) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/basket/${basketId}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    basketAddCustomer(basketId, customer) {

        const siteId = this.getSiteId();

        const dataToSend = {
            first_name: customer.firstname,
            last_name: customer.surname,
            email: customer.email
        }

        return this.http.post(`${environment.apiV2Path}trybe/${siteId}/basket/${basketId}/customer`, dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    basketSubmit(basketId) {

        const siteId = this.getSiteId();

        const dataToSend = {}

        return this.http.post(`${environment.apiV2Path}trybe/${siteId}/basket/${basketId}/submit`, dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    basketAddPackageItem(offeringId, basketId, date, guests) {

        const siteId = this.getSiteId();

        const dataToSend = {
            offering_type: 'package',
            offering_id: offeringId,
            date,
            guests
        }

        return this.http.post(`${environment.apiV2Path}trybe/${siteId}/basket/${basketId}/package/add`, dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }


    basketAddPackageItemOption(basket, offering, date) {

        const siteId = this.getSiteId();

        const dataToSend = {
            "choice_id": basket.items[0].option_budgets[0].choice_id,
            "option_id": offering.id,
            "time": `${date}T00:00:00+01:00`,
            "item_configuration": {
                "choice_id": basket.items[0].option_budgets[0].choice_id,
                "option_id": offering.id,
                "time": `${date}T00:00:00+01:00`,
            },
            "basketItemId": basket.items[0].id,
            "basket_id": null
        }
        console.log(dataToSend)
        return this.http.post(`${environment.apiV2Path}trybe/${siteId}/basket/${basket.id}/items/${basket.items[0].id}/package-items`, dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    basketAddItem(basketId, offering, appointment, guests) {

        const siteId = this.getSiteId();

        const dataToSend = {
            offering_type: offering.type,
            offering_id: offering.id,
            time: appointment.start_time,
            quantity: 1,
            guests: []
        }
        if (offering.min_guests > 1) {
            dataToSend.guests = guests
        } else {
            dataToSend.guests.push(guests)
        }

        return this.http.post(`${environment.apiV2Path}trybe/${siteId}/basket/${basketId}/items`, dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    basketRemoveItem(basketId, itemId) {

        const siteId = this.getSiteId();

        return this.http.delete(`${environment.apiV2Path}trybe/${siteId}/basket/${basketId}/items/${itemId}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    getCategories() {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/categories`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    getOfferings(categoryId) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/offerings/${categoryId}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    getOffering(offeringType, offeringId) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/offering/${offeringType}/${offeringId}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    getOfferingCrossSell(offeringType, offeringId) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/offering/${offeringType}/${offeringId}/crosssell`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    getOfferingUpSell(offeringType, offeringId) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/offering/${offeringType}/${offeringId}/upsell`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    getItemAvailability(offeringType, offeringId, dateFrom, dateTo, quantity) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/offering/availability/${offeringType}/${offeringId}/${dateFrom}/${dateTo}/${quantity}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    getTimeSlots(offeringType, offeringId, dateFrom) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/offering/${offeringType}/${offeringId}/appointment-slots/${dateFrom}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    getPackage(packageId) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/packages/${packageId}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }


    getPackageTimeSlots(offeringType, packageId, choiceId, dateFrom) {

        const siteId = this.getSiteId();

        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/offering/${offeringType}/${packageId}/package-slots/${choiceId}/${dateFrom}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    getSpaOrder(trybeOrderId, siteId) {
        return this.http.get(`${environment.apiV2Path}trybe/${siteId}/order/` + trybeOrderId).pipe(map((data: any) => {
            return data;
        }));
    }

    cancelSpaOrder(trybeOrderId, siteId) {
        return this.http.delete(`${environment.apiV2Path}trybe/${siteId}/orders/${trybeOrderId}/cancel/`).pipe(map((data: any) => {
            return data;
        }));

    }

    basketAddSpaPackageItemOption(basketId, basketItemId, optionData, date) {
        const siteId = this.getSiteId();
        const dataToSend = optionData;



        dataToSend.basketItemId = basketItemId;


        return this.http.post(`${environment.apiV2Path}trybe/${siteId}/basket/${basketId}/items/${dataToSend.basketItemId}/package-items`, dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    removePackageOption(basketId, itemId, packageItemId) {
        const siteId = this.getSiteId();
        return this.http.delete(`${environment.apiV2Path}trybe/${siteId}/basket/${basketId}/items/${itemId}/package-items/${packageItemId}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

}
